<template>
  <div
    style="background-color: #f1f4f8; height: auto; min-height: 100% !important"
  >
    <div class="d-flex align-center pt-4 mb-7 ml-5">
      <h1 class="font-weight-bold mr-4" style="font-size: 22px">Relatórios</h1>
      <div max-width="300">
        <v-autocomplete
          :items="reportsCategory"
          v-model="reportsSelected"
          item-value="id"
          item-text="name"
          label="Relatórios..."
          single-line
          rounded
          hide-details
          dense
          @change="changeTable"
          solo
          flat
        ></v-autocomplete>
      </div>
    </div>
    <ReportsHistory
      v-if="reportsSelected === 1"
      pageTitle="Relatórios gerais"
      :reports="reports"
      :loading="loading"
      :showDataTable="showDataTable"
      :period-selected="periodCompany"
      @reload:reports="getCompanyReports"
      @update:period-selected="
        handleUpdatePeriod('periodCompany', $event, getCompanyReports)
      "
      itemKey="created_at"
    />
    <ReportsHistory
      v-if="reportsSelected === 2"
      pageTitle="Contas de usuário"
      :reports="reportsAccounts"
      :loading="loading"
      :showDataTable="showDataTable"
      :period-selected="periodAccounts"
      @reload:reports="getAccountsReports"
      @update:period-selected="
        handleUpdatePeriod('periodAccounts', $event, getAccountsReports)
      "
      itemKey="created_at"
    />
    <ReportsHistory
      v-if="reportsSelected === 3"
      pageTitle="Assinaturas de e-mail"
      :reports="reportsSignatures"
      :loading="loading"
      :showDataTable="showDataTable"
      :period-selected="periodSignatures"
      @reload:reports="getSignatureEmailReports"
      @update:period-selected="
        handleUpdatePeriod('periodSignatures', $event, getSignatureEmailReports)
      "
    />

    <ReportsHistory
      v-if="reportsSelected === 4"
      pageTitle="Permissões de usuário"
      :reports="reportsPermission"
      :loading="loading"
      :showDataTable="showDataTable"
      :period-selected="periodPermission"
      :applyUtc="false"
      @reload:reports="getUserPermissionReports"
      @update:period-selected="
        handleUpdatePeriod('periodPermission', $event, getUserPermissionReports)
      "
    />

    <ReportsHistory
      v-if="reportsSelected === 5"
      pageTitle="Migrações de e-mail"
      :reports="reportsMigration"
      :loading="loading"
      :showDataTable="showDataTable"
      :period-selected="periodMigrations"
      :applyUtc="false"
      @reload:reports="getEmailMigrationReports"
      @update:period-selected="
        handleUpdatePeriod('periodMigrations', $event, getEmailMigrationReports)
      "
      itemKey="created_at"
    />

    <ReportsHistory
      v-if="reportsSelected === 6"
      pageTitle="Aplicações de férias"
      :reports="reportsVacation"
      :loading="loading"
      :showDataTable="showDataTable"
      :period-selected="periodVacations"
      :applyUtc="false"
      @reload:reports="getVacationApplyReports"
      @update:period-selected="
        handleUpdatePeriod('periodVacations', $event, getVacationApplyReports)
      "
      itemKey="created_at"
    />
  </div>
</template>
<script>
import ReportsHistory from "@/components/logs/ReportsHistory.vue";
import { subtractDays } from "@/helpers/services/utils";
import {
  SUITE_DEV_PROJECT_NAME,
  SUITE_PROD_PROJECT_NAME,
} from "@/helpers/variables/backendConstants";
import { mapGetters } from "vuex";
export default {
  name: "Reports",
  components: {
    ReportsHistory,
  },

  data() {
    return {
      reportsSelected: 1,
      reports: [],
      reportsAccounts: [],
      reportsSignatures: [],
      reportsPermission: [],
      reportsMigration: [],
      reportsVacation: [],
      loading: false,
      pageHeight: 0,
      showDataTable: false,
      reportsCategory: [
        { name: "Gerais", id: 1 },
        { name: "Contas de usuário", id: 2 },
        { name: "Assinaturas de e-mail", id: 3 },
        { name: "Permissões de usuário", id: 4 },
        { name: "Migrações de e-mail", id: 5 },
        { name: "Aplicações de férias", id: 6 },
      ],
      periodCompany: {
        textKey: "common.past7Days",
        value: subtractDays(7),
      },
      periodAccounts: {
        textKey: "common.past7Days",
        value: subtractDays(7),
      },
      periodSignatures: {
        textKey: "common.past7Days",
        value: subtractDays(7),
      },
      periodPermission: {
        textKey: "common.past7Days",
        value: subtractDays(7),
      },
      periodMigrations: {
        textKey: "common.past7Days",
        value: subtractDays(7),
      },
      periodVacations: {
        textKey: "common.past7Days",
        value: subtractDays(7),
      },
    };
  },
  computed: {
    ...mapGetters(["token", "clientToken", "isResellerPage", "company"]),
  },
  methods: {
    async changeTable() {
      const reportMap = {
        1: { data: this.reports, method: this.getCompanyReports },
        2: { data: this.reportsAccounts, method: this.getAccountsReports },
        3: {
          data: this.reportsSignatures,
          method: this.getSignatureEmailReports,
        },
        4: {
          data: this.reportsPermission,
          method: this.getUserPermissionReports,
        },
        5: {
          data: this.reportsMigration,
          method: this.getEmailMigrationReports,
        },
        6: {
          data: this.reportsVacation,
          method: this.getVacationApplyReports,
        },
      };

      const selected = reportMap[this.reportsSelected];
      if (selected && !selected.data.length) {
        await selected.method.call(this);
      }
    },

    async getCompanyReports() {
      this.loading = true;

      let clientToken = "";
      if (this.isResellerPage && this.clientToken) {
        clientToken = `Bearer ${this.clientToken}`;
      }

      const from_date = this.periodCompany.value;
      const url = `${process.env.VUE_APP_API_BASE_URL}/company/history?from_date=${from_date}`;

      const config = {
        headers: {
          Authorization: clientToken ? clientToken : this.token,
        },
      };

      await this.$axios
        .get(url, config)
        .then(({ data }) => {
          this.reports = data;
          this.reports.concat(data);
        })
        .catch((err) => {
          this.showSnackBarError = true;
          console.error("getCompanyReports()", err);
        })
        .finally(() => (this.loading = false));
    },

    getAccountsReports() {
      this.loading = true;

      let companyKey = "";
      if (this.isResellerPage) {
        companyKey = this.$route.query.key;
      }

      const from_date = this.periodAccounts.value;
      const url = `${process.env.VUE_APP_BIG_QUERY_API}/get-logs?from_date=${from_date}`;

      const config = {
        params: {
          company_key: companyKey ? companyKey : this.company.key,
          query: "accounts",
          project_name:
            process.env.NODE_ENV !== "production"
              ? SUITE_DEV_PROJECT_NAME
              : SUITE_PROD_PROJECT_NAME,
        },
      };

      this.$axios
        .get(url, config)
        .then(({ data }) => {
          this.reportsAccounts = data;
        })
        .catch((err) => {
          this.setSnackBar({
            message: this.errorMessages.LOG_ERROR,
            color: "error",
            show: true,
          });
          console.error("getAccountsReports()", err);
        })
        .finally(() => (this.loading = false));
    },

    async getSignatureEmailReports() {
      this.loading = true;

      let clientToken = "";
      if (this.isResellerPage && this.clientToken) {
        clientToken = `Bearer ${this.clientToken}`;
      }

      const from_date = this.periodSignatures.value;
      const url = `${process.env.VUE_APP_API_BASE_URL}/company/history/signature?from_date=${from_date}`;

      const config = {
        headers: {
          Authorization: clientToken ? clientToken : this.token,
        },
      };

      await this.$axios
        .get(url, config)
        .then(({ data }) => {
          this.reportsSignatures = data;
        })
        .catch((err) => {
          this.setSnackBar({
            message:
              "Erro ao recuperar os registros de assinatura, tente novamente.",
            color: "error",
            show: true,
          });
          console.error("getSignatureEmailReports()", err);
        })
        .finally(() => (this.loading = false));
    },

    async getUserPermissionReports() {
      this.loading = true;

      let clientToken = "";
      if (this.isResellerPage && this.clientToken) {
        clientToken = `Bearer ${this.clientToken}`;
      }

      const from_date = this.periodPermission.value;
      const url = `${process.env.VUE_APP_API_BASE_URL}/company/history/user-permission?from_date=${from_date}`;

      const config = {
        headers: {
          Authorization: clientToken ? clientToken : this.token,
        },
      };

      await this.$axios
        .get(url, config)
        .then(({ data }) => {
          this.reportsPermission = data;
        })
        .catch((err) => {
          this.setSnackBar({
            message:
              "Erro ao carregar os registros permissão de usuário, tente novamente.",
            color: "error",
            show: true,
          });
          console.error("getUserPermissionReports()", err);
        })
        .finally(() => (this.loading = false));
    },

    async getEmailMigrationReports() {
      this.loading = true;

      let clientToken = "";
      if (this.isResellerPage && this.clientToken) {
        clientToken = `Bearer ${this.clientToken}`;
      }

      const from_date = this.periodMigrations.value;
      const url = `${process.env.VUE_APP_API_BASE_URL}/company/history/email-migration?from_date=${from_date}`;

      const config = {
        headers: {
          Authorization: clientToken ? clientToken : this.token,
        },
      };

      await this.$axios
        .get(url, config)
        .then(({ data }) => {
          this.reportsMigration = data;
        })
        .catch((err) => {
          this.setSnackBar({
            message: "Erro ao carregar os registros de migração de emails.",
            color: "error",
            show: true,
          });
          console.error("getEmailMigrationReports()", err);
        })
        .finally(() => (this.loading = false));
    },

    async getVacationApplyReports() {
      this.loading = true;

      let clientToken = "";
      if (this.isResellerPage && this.clientToken) {
        clientToken = `Bearer ${this.clientToken}`;
      }

      const from_date = this.periodVacations.value;
      const url = `${process.env.VUE_APP_API_BASE_URL}/company/history/vacation?from_date=${from_date}`;

      const config = {
        headers: {
          Authorization: clientToken ? clientToken : this.token,
        },
      };

      await this.$axios
        .get(url, config)
        .then(({ data }) => {
          this.reportsVacation = data;
        })
        .catch((err) => {
          this.setSnackBar({
            message:
              "Erro ao carregar os registros de Aplicações de férias, tente novamente.",
            color: "error",
            show: true,
          });
          console.error("getVacationApplyReports()", err);
        })
        .finally(() => (this.loading = false));
    },

    handleResize() {
      this.pageHeight = window.innerHeight;
    },

    async handleUpdatePeriod(periodSelected, event, reportGetter) {
      this[periodSelected] = event;
      await reportGetter();
    },
  },
  async beforeMount() {
    if (!this.isResellerPage) {
      await this.getCompanyReports();
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
